import storageUtils from "helpers/storageUtils";
import { API } from "services/enum/api";
import { axiosClient } from "services/fetcher";
import urlcat from "urlcat";

const visitorMapper = (id: number, fields: any) => ({
  id,
  firstName: fields.first_name as Visitor['firstName'],
  lastName: fields.last_name as Visitor['lastName'],
  email: fields.email as Visitor['email'],
  position: fields.position as Visitor['position'],
  companyName: fields.company_name as Visitor['companyName'],
  oldCompanyName: fields.old_company_name as Visitor['oldCompanyName']
});

const serviceCheckIn = async (data: Visitor): Promise<IResponseType<any>> => {
  try {
    const existingVisitor = await axiosClient.get(urlcat(API.VISITOR_BY_EMAIL, { email: data.email }));

    if (existingVisitor.status === 200 && existingVisitor.data?.data?.[0]) {
      storageUtils.saveVisitorToLocalStorage(visitorMapper(existingVisitor.data.data[0].id, existingVisitor.data.data[0])); // Save existing visitor to local storage
      return { success: true, data: existingVisitor.data.data[0] };
    }

    const payload = {
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      position: data.position,
      company_name: data.companyName
    }

    const res = await axiosClient.post(API.CHECK_IN, { data: payload });

    const createdVisitor = res.data.data;
    const newVisitor = visitorMapper(createdVisitor.id, createdVisitor);
    storageUtils.saveVisitorToLocalStorage(newVisitor);

    return { success: true, data: newVisitor };

  } catch (error) {
    return { success: false, error, data: undefined };
  }
};

const serviceUpdateVisitor = async (data: Visitor): Promise<IResponseType<any>> => {
  try {
    const existingVisitor = await axiosClient.get(urlcat(API.VISITOR_BY_EMAIL, { email: data.email }));

    if (existingVisitor.status === 200 && existingVisitor.data?.data?.[0]) {
      storageUtils.saveVisitorToLocalStorage(visitorMapper(existingVisitor.data.data[0].id, existingVisitor.data.data[0])); // Save existing visitor to local storage
      return { success: true, data: existingVisitor.data.data[0] };
    }

    const payload = {
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      position: data.position,
      company_name: data.companyName,
      old_company_name: data.oldCompanyName
    }

    const res = await axiosClient.post(API.CHECK_IN, { data: payload });

    const createdVisitor = res.data.data;
    const newVisitor = visitorMapper(createdVisitor.id, createdVisitor);
    storageUtils.saveVisitorToLocalStorage(newVisitor);

    return { success: true, data: newVisitor };

  } catch (error) {
    return { success: false, error, data: undefined };
  }
};

const serviceGetVisitorByEmail = async (email: string): Promise<IResponseType<any>> => {
  try {
    const res = await axiosClient.get(urlcat(API.VISITOR_BY_EMAIL, { email }));
    return { success: true, data: res.data.data };
  } catch (error) {
    return { success: false, error, data: undefined };
  }
};

export {
  serviceCheckIn,
  serviceUpdateVisitor,
  serviceGetVisitorByEmail
};
